module.exports = {
          srcSet: __webpack_public_path__ + "images/2023-928d2e93824f17b2d6e4871eb0a19719-320.jpg"+" 320w"+","+__webpack_public_path__ + "images/2023-fbe3208bb313fb0161fbabe4dce44995-370.jpg"+" 370w",
          images:[ {path: __webpack_public_path__ + "images/2023-928d2e93824f17b2d6e4871eb0a19719-320.jpg",width: 320,height: 251},{path: __webpack_public_path__ + "images/2023-fbe3208bb313fb0161fbabe4dce44995-370.jpg",width: 370,height: 290}],
          src: __webpack_public_path__ + "images/2023-928d2e93824f17b2d6e4871eb0a19719-320.jpg",
          toString:function(){return __webpack_public_path__ + "images/2023-928d2e93824f17b2d6e4871eb0a19719-320.jpg"},
          
          width: 320,
          height: 251
        }